module.exports = __webpack_public_path__ + "img/dna.3dc7590b.svg";